// Auto-generated team name for excludeTeamName formats (doubles/pairs, etc.),
// where a team is identified by its players rather than a typed name. The name is
// created in the background — never shown to or typed by the user — using the
// `zqtm_` prefix so isAutoGeneratedTeamName recognizes it and getTeamDisplayName
// renders the players' names instead of the placeholder.
//
// Single source of truth for the prefix + the generator; both the admin division
// "Add Team" flow and the public registration/embed flows use these.
export const AUTO_TEAM_NAME_PREFIX = 'zqtm_';

export default function generateAutoTeamName(): string {
  return `${AUTO_TEAM_NAME_PREFIX}${Date.now()}`;
}
